import { useMutation } from '@tanstack/react-query'
import { IRequestData } from '@zet/customer/src/api/functions/customerAdditionStateMachine'
import { zetApi } from '@zet/network'

const editBasicDetails = async (requestData: IRequestData) => {
  const { data } = await zetApi.post('jfs/editCustomerDetails', requestData)
  if (data?.data) {
    return data.data
  } else {
    return data?.error
  }
}

const useEditBasicDetails = () => {
  return useMutation(editBasicDetails, {
    mutationKey: ['editBasicDetails'],
  })
}

export { useEditBasicDetails }
